module.exports = __webpack_public_path__ + "static/media/Step6_ModuloAgenda.7e6efe47.png";